module.exports = __webpack_public_path__ + "static/img/can-grapefruit.393e3ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-grapefruit.png
// module id = d+2Q
// module chunks = 0